import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getCustomers (filter) {
    return Http.get({
      url: `customers${filter}`
    })
  },
  getSmsLogs (filter) {
    return Http.get({
      url: `customer-sms-logs${filter}`
    })
  },
  getMessages (filter) {
    return Http.get({
      url: `messages${filter}`
    })
  },
  getCustomer (customerId) {
    return Http.get({
      url: `customers/${customerId}`
    })
  },
  getCustomerInvoiceCustomerCreateForm (customerId) {
    return Http.get({
      url: `customer/${customerId}/invoice-customers/form`
    })
  },
  postCustomerInvoiceCustomerCreateForm (customerId, formData) {
    return Http.post({
      url: `customer/${customerId}/invoice-customers/form`,
      data: formData
    })
  },
  putCurrentInvoiceCustomerOnCustomer (customerId, formData) {
    return Http.put({
      url: `customer/${customerId}/current-invoice-customers`,
      data: formData
    })
  },
  deleteInvoiceCustomerOnCustomer: function (customerId) {
    return Http._delete({
      url: `customer/${customerId}/current-invoice-customers`
    })
  },
  getMessageForm (caseId) {
    return Http.get({
      url: `messages/${caseId}/form`
    })
  },
  putMessageForm (caseId, formData) {
    return Http.post({
      url: `messages/${caseId}/form`,
      data: Transform.createMultipartFormData(formData)
    })
  },
  getSendSmsForm (customerId) {
    return Http.get({
      url: `customer/send-sms/${customerId}`
    })
  },
  putSendSmsForm (customerId, formData) {
    return Http.put({
      url: `customer/send-sms/${customerId}`,
      data: formData
    })
  },
  putSendCaseSmsForm (customerId, caseId, formData) {
    return Http.put({
      url: `customer/case/send-sms/${customerId}/${caseId}`,
      data: formData
    })
  },
  getCustomerLogs (customerId) {
    return Http.get({
      url: `customers/${customerId}/logs`
    })
  }
}
